import { render, staticRenderFns } from "./BaselineProgressBar.vue?vue&type=template&id=2b531a2f&scoped=true&"
import script from "./BaselineProgressBar.vue?vue&type=script&lang=ts&"
export * from "./BaselineProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./BaselineProgressBar.vue?vue&type=style&index=0&id=2b531a2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b531a2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
